import { getWindowObject } from '@eventbrite/feature-detection';
import { CheckoutLifecycleEventPostMessageName } from './CheckoutLifecycleEventPostMessageName';

export const postMessage = ({
    additionalData = {},
    eventId,
    messageName,
    widgetParentUrl,
}: {
    additionalData?: Record<string, unknown>;
    eventId?: string;
    messageName: CheckoutLifecycleEventPostMessageName;
    widgetParentUrl?: string;
}): void => {
    // When testing Checkout we sometimes access it directly through
    // `/checkout-external`, without passing a parent URL
    // We do not want this helper to crash in that situation, so we just make it
    // a noop instead
    if (!widgetParentUrl) {
        return;
    }

    getWindowObject('parent')?.postMessage(
        {
            ...additionalData,
            messageName,
            eventId,
        },
        widgetParentUrl,
    );
};
